import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormArray,
  FormBuilder,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { WorkgroupPrivilege } from "models/users/user-workgroups";
import { CompanyDetails } from "../company-details";

@Component({
  selector: "workgroup-permissions",
  templateUrl: "workgroup-permissions.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkgroupPermissions),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => WorkgroupPermissions),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkgroupPermissions
  extends CompanyDetails
  implements ControlValueAccessor, OnDestroy, OnChanges
{
  @Input() isEditMode: boolean = false;
  @Input() workgroupId: number;

  _permissionGroups: WorkgroupPrivilege[] = [];
  _bucketName: string;

  @Input()
  set permissionGroups(value: any) {
    this._permissionGroups = value;
  }

  get permissionGroups() {
    return this._permissionGroups;
  }

  get bucketName(): string {
    return this._bucketName;
  }

  @Input()
  set bucketName(value: string) {
    this._bucketName = value;
  }

  constructor(protected formBuilder: FormBuilder) {
    super(formBuilder);
    // create inner form
    this.innerFormGroup = this.formBuilder.group({});

    this.subscriptions.push(
      this.innerFormGroup.valueChanges.subscribe((value) => {
        this.onChange(value);
        this.onTouched();
      })
    );
    // //Request to get the permissionGroups Value By Id
    // this.innerFormGroup.patchValue(this.reformatForm(this.permissionGroups));
  }

  // Reformat the form to match the form Array format
  reformatForm(data: WorkgroupPrivilege[]) {
    let formData: any = [];
    var groupFormArray = new FormArray([]);

    for (let group of data) {
      let view = false;
      let add = false;
      let update = false;
      let del = false;

      if (Number(group.privilegeAccess & 1) > 0) {
        add = true;
      }

      if (Number(group.privilegeAccess & 2) > 0) {
        view = true;
      }

      if (Number(group.privilegeAccess & 4) > 0) {
        update = true;
      }

      if (Number(group.privilegeAccess & 8) > 0) {
        del = true;
      }

      const groupForm = this.formBuilder.group({
        view: [view],
        edit: [update],
        add: [add],
        delete: [del],
        domainName: [group.domainName],
        domainId: [group.domainId],
      });
      groupFormArray.push(groupForm);
    }

    this.innerFormGroup.addControl("permissions", groupFormArray);
    return formData;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.permissionGroups &&
      changes.permissionGroups.currentValue &&
      changes.permissionGroups.currentValue.length > 0
    ) {
      this.reformatForm(
        changes.permissionGroups.currentValue as WorkgroupPrivilege[]
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/permissions/workgroup-permissions.ts